export default __webpack_public_path__ + "static/media/competitors_icon.b86aa242.svg";